import { IPersonaProps, PersonaInitialsColor } from 'office-ui-fabric-react'
import { User } from '../gql.generated'

export function mapUserToUserPersonaMaybeArray(
  user: User | User[] | undefined | null
): IPersonaProps[] {
  if (!user) {
    return []
  }
  let users: User[]

  Array.isArray(user) ? (users = user) : (users = [user])
  return users.map((u) => mapUserToUserPersona(u))
}

export const mapUserToUserPersona = (user: User): IPersonaProps =>
  ({
    userId: user._id,
    text: user.name,
    secondaryText: user.email,
    initialsColor: PersonaInitialsColor.lightRed,
    tertiaryText:
      user.extension === null
        ? `DVT/WVT | ${user.department || '---'}`
        : user.extension === 'INTERN' &&
          user.companyName === 'Dr. Ing. h.c. F. Porsche AG'
        ? `Porsche AG intern | ${user.department || '---'}`
        : user.extension === 'INTERN' &&
          user.companyName !== 'Dr. Ing. h.c. F. Porsche AG'
        ? `DVT/WVT | ${user.department || '---'}`
        : user.extension === 'EXTERN'
        ? `DVT/WVT | ${user.department || '---'}`
        : user.extension === 'ANUE' &&
          user.companyName !== 'Dr. Ing. h.c. F. Porsche AG'
        ? `DVT/WVT | ${user.department || '---'}`
        : user.extension === 'ANUE' &&
          user.companyName === 'Dr. Ing. h.c. F. Porsche AG'
        ? `ANÜ | ${user.department || '---'}`
        : user.extension === 'TEMP' &&
          user.companyName !== 'Dr. Ing. h.c. F. Porsche AG'
        ? `DVT/WVT | ${user.department || '---'}`
        : user.extension === 'TEMP' &&
          user.companyName === 'Dr. Ing. h.c. F. Porsche AG'
        ? `Porsche AG intern | ${user.department || '---'}`
        : '---',

    // `${getParticipantTypeDisplayName(
    //   user as any,
    //   t
    // )} | ${user.department || '---'}`,
    // user.external
    //   ? user.department
    //     ? `DVT/WVT | ${user.department}`
    //     : 'DVT/WVT'
    //   : `Porsche AG | ${user.department || '---'}`,
  } as IPersonaProps)
